import graphqlClient from "@/GQLClient";
import {
  GetExternalGroupListDocument,
  GetGroupListDocument,
  Group_Connection,
  type GetExternalGroupListQuery,
  type GetGroupListQuery,
} from "@/graphql/generated-types";
import { GraphQLError } from "graphql";

const getGroups = async (): Promise<GetGroupListQuery> => {
  const response = await graphqlClient.query({
    query: GetGroupListDocument,
    fetchPolicy: "no-cache",
  });

  if (response.data.institutions?.getMyInstitution.groups) {
    return response.data;
  }

  throw new GraphQLError(`api.groups.getGroups`);
};

const getExternalGroups = async (
  type: Group_Connection,
): Promise<GetExternalGroupListQuery> => {
  const response = await graphqlClient.query({
    query: GetExternalGroupListDocument,
    fetchPolicy: "no-cache",
    variables: {
      type,
    },
  });

  if (response.data.institutions?.getMyInstitution.externalGroups) {
    return response.data;
  }

  throw new GraphQLError(`api.groups.getExternalGroups`);
};

export default {
  getGroups,
  getExternalGroups,
};
